import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';

import doodle from './doodle.png';
import css from './RequestMatchingOffersCard.module.css';

/**
 * A promotional card interspersed in the search results grid that invites the
 * user to request matching offers when they can't find a suitable listing.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default root class
 * @param {string} [props.rootClassName] - Custom class that overrides the default root class
 * @returns {JSX.Element}
 */
const RequestMatchingOffersCard = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.content}>
        <img className={css.doodle} src={doodle} alt="" aria-hidden="true" />
        <h3 className={css.title}>
          <FormattedMessage id="RequestMatchingOffersCard.title" />
        </h3>
      </div>
      <NamedLink
        className={css.button}
        name="NewAlertPage"
      >
        <FormattedMessage id="RequestMatchingOffersCard.buttonLabel" />
      </NamedLink>
    </div>
  );
};

export default RequestMatchingOffersCard;
